import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions'
import SearchBox from '../components/SearchBox';
import { loadTaxonomyAsyncThunk, searchTaxonomyAsyncThunk, applyFilter, removeFilter, resetAndReplaceFilter, setProductProperty } from '../actions/ProductsSearchActions'
import { updateOrderSheetAsyncThunk, addOrderItem, changeItemQuantity, removeOrderItem, getOrderSheetsAsyncThunk } from '../../Home/actions/OrderSheetsActions';

import { ThunkDispatch } from 'redux-thunk';
import { SearchFilter, CategoryFilter, PropertyFilter } from '../../models/SearchFilter';
import { toProductsList } from '../selectors';
import { RouteComponentProps } from 'react-router';
import { createOrderAndQuoteItThunk } from '../../Quote/actions/OrderActions';
import { OrderSheetData, OrderSheetItemData } from '../../api/models/OrderSheetData';
import { CreateOrderModel } from '../../api/models/OrderData';


const mapStateToProps = (state: RootState) => ({
  taxonomyLeafs: state.productsSearchRdc.taxonomyLeafs,
  taxonomy: state.productsSearchRdc.taxonomy,
  currentProducts: toProductsList(state.productsSearchRdc.searchResults),
  facetResults: state.productsSearchRdc.categoriesFacetResult,
  appliedCategoryFilters: state.productsSearchRdc.appliedCategoryFilters,
  currentCategoryFilters: state.productsSearchRdc.currentCategoryFilters,
  topCategoryFilters: state.productsSearchRdc.topCategoryFilters,
  appliedPropertyFilters: state.productsSearchRdc.appliedPropertyFilters,
  currentProductProperties: state.productsSearchRdc.currentProductProperties,
  searchBusy: state.productsSearchRdc.searchBusy,
  totalResults: state.productsSearchRdc.totalResults,
  highlights: state.productsSearchRdc.highlights,
  currentOrderSheet: state.orderSheetsRdc.currentOrderSheet,
  updateOrderSheetBusy: state.orderSheetsRdc.updateOrderSheetBusy,
  orderSheetBusy: state.orderSheetsRdc.isBusy,
  orderSheetDirty: state.orderSheetsRdc.currOrderSheetDirty
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    loadTaxonomy: async () => {
      await dispatch(loadTaxonomyAsyncThunk())
    },
    addOrderItem: (prod: OrderSheetItemData) => {
      dispatch(addOrderItem(prod))
    },
    removeOrderItem: (prod: OrderSheetItemData) => {
      dispatch(removeOrderItem(prod))
    },
    changeOrderItemQuantity: (prod: OrderSheetItemData) => {
      dispatch(changeItemQuantity(prod))
    },
    renameOrderSheet: async (orderSheet: OrderSheetData) => {
      await dispatch(updateOrderSheetAsyncThunk(orderSheet))
    },
    searchTaxonomy: async (query: string, startFrom: number, limit: number, filters: { [name: string]: string[] }) => {
      await dispatch(searchTaxonomyAsyncThunk(query, startFrom, limit, filters, true))
    },
    applyFilter: (filter: SearchFilter) => {
      dispatch(applyFilter(filter))
    },
    removeFilter: (filter: SearchFilter) => {
      dispatch(removeFilter(filter))
    },
    replaceFilter: (categoryFilter?: CategoryFilter | null, propertyFilter?: PropertyFilter | null) => {
      dispatch(resetAndReplaceFilter({ categoryFilter, propertyFilter }))
    },
    updateOrderSheet: async (orderSheet: OrderSheetData) => {
      await dispatch(updateOrderSheetAsyncThunk(orderSheet))
    },
    createOrderAndQuoteIt: async (orderData: CreateOrderModel ) => {
      await dispatch(createOrderAndQuoteItThunk(orderData))
    },
    updateProductProperty: (product: OrderSheetItemData) => {
      dispatch(setProductProperty(product))
    },
    getOrderSheets: async () => {
      await dispatch(getOrderSheetsAsyncThunk())
  }

  }
}

export type ProductsSearchBoxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any>

export const ProductsSearchBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBox);